const rankings = [
  {
    id: 1,
    rank: 1,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20book%20cover%20massive%20spaceship%20over%20burning%20planet%20hero%20in%20foreground%20dramatic%20pose%20epic%20scale%20warm%20orange%20explosion%20colors%20manga%20style%20illustration%20title%20area%20at%20top&width=200&height=260&seq=ranking-comic-1&orientation=portrait',
    title: '银河远征队',
    tag: '星际战争',
    author: '星河',
    status: '连载中',
    heat: '9.8',
  },
  {
    id: 2,
    rank: 2,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20cover%20female%20space%20pilot%20in%20cockpit%20stars%20streaking%20past%20window%20determined%20expression%20warm%20cockpit%20lighting%20dramatic%20manga%20art%20style%20detailed%20illustration&width=200&height=260&seq=ranking-comic-2&orientation=portrait',
    title: '深空迷航',
    tag: '太空冒险',
    author: '辰星',
    status: '连载中',
    heat: '9.6',
  },
  {
    id: 3,
    rank: 3,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20cover%20ancient%20alien%20temple%20on%20desert%20world%20giant%20stone%20carvings%20glowing%20runes%20explorer%20with%20lantern%20mysterious%20atmosphere%20warm%20golden%20light%20manga%20style&width=200&height=260&seq=ranking-comic-3&orientation=portrait',
    title: '深渊遗迹',
    tag: '外星文明',
    author: '墨羽',
    status: '连载中',
    heat: '9.4',
  },
  {
    id: 4,
    rank: 4,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20cover%20cybernetic%20warrior%20in%20futuristic%20city%20neon%20lights%20raining%20night%20holding%20energy%20blade%20dramatic%20pose%20warm%20orange%20neon%20manga%20illustration&width=200&height=260&seq=ranking-comic-4&orientation=portrait',
    title: '星甲战神',
    tag: '超级英雄',
    author: '炎风',
    status: '连载中',
    heat: '9.2',
  },
  {
    id: 5,
    rank: 5,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20cover%20Mars%20colony%20under%20red%20sky%20settlers%20looking%20up%20at%20approaching%20dust%20storm%20dramatic%20scale%20warm%20red%20orange%20tones%20manga%20art%20style%20detailed&width=200&height=260&seq=ranking-comic-5&orientation=portrait',
    title: '红色家园',
    tag: '火星殖民',
    author: '朔月',
    status: '连载中',
    heat: '9.0',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            人气榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            读者热度排行，发现最受欢迎的科幻漫画
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {rankings.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="flex items-center gap-3 md:gap-4 bg-background-100 rounded-lg p-3 md:p-4 border border-background-200/60 hover:border-accent-300/50 transition-colors no-underline cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full font-heading font-bold text-sm md:text-base flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-secondary-200 text-foreground-700'
              }`}>
                {item.rank}
              </div>

              <div className="w-12 h-16 md:w-14 md:h-20 rounded overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs bg-primary-50 text-primary-600 px-2 py-0.5 rounded-full whitespace-nowrap font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400 flex-wrap">
                  <span className="whitespace-nowrap">作者：{item.author}</span>
                  <span className="whitespace-nowrap">{item.status}</span>
                </div>
              </div>

              <div className="flex items-center gap-1 flex-shrink-0">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-fill text-primary-500 text-sm"></i>
                </span>
                <span className="text-sm md:text-base font-bold text-primary-600 whitespace-nowrap">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}